const homepageBannerInit = () => {
  const mainPattern = document.querySelectorAll('.gg-hero-banner');
  mainPattern.forEach((module) => {
    const blockCover = module.querySelector('.wp-block-cover');
    const img = blockCover.querySelector('.wp-block-cover__image-background');
    const containerWrapper = blockCover.querySelector('.wp-block-cover__inner-container').querySelector('.gg-content-wrapper');
    if(!img) {
      containerWrapper.style.maxWidth = '900px';
    }
    if (img && window.innerWidth > 1024) {
      setTimeout(() => {
        const { clientWidth: widthImage, clientHeight: heightImage } = img;
        if (widthImage < heightImage) {
          img.style.maxWidth = `554px`;
          img.classList.add('update-maxWidth-image');
        }
      }, 1000);
    }
  });
};
homepageBannerInit();
